import {
  escapeHtml
} from '../util/escape';

export function TextFactDirective($compile, $log) {
  const fixedString = function(s, wl) {
    const l = s.length;
    return l > wl + 5 ? s.slice(0, wl / 2) + '.. ..' + s.slice(l - wl / 2, l) : s;
  };

  function format_fact(fact, short, hideSystemKeys) {
    let html = fact.text_data.replace(/^[\s\n\r]*/gm, '');
    const regexStart = /{{/ig;
    const regexEnd = /}}/ig;
    html = html
      .replaceAll(regexStart, '&#123; &#123;')
      .replaceAll(regexEnd, '&#125; &#125;');
    const eventName = fact['agent_eventtype.name'];

    if (eventName === 'FileOperation') {
      html = escapeHtml(html);

      if (short) {
        const wl = 40;
        html = html.split('\n').reduce(function(a, b, c) {
          return a + (c == 0 && html.indexOf('\n') != -1 ? '<b>' +
              gettext('Из') + '</b> ' : '') +
            (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + fixedString(
              b,
              wl,
            ) + (c === 0 ? ' ' : '');
        }, '');
      } else {
        html = html.split('\n').reduce(function(a, b, c) {
          return a + (c == 0 && html.indexOf('\n') != -1 ? '<b>' + gettext('Из') +
              '</b> ' : '') + (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + b +
            (c === 0 ? ' ' : '');
        }, '');
      }
    } else {
      if (fact['agent_eventtype.id'] == 1 && hideSystemKeys) {
        const originText = html;
        const noBabgeText = html.replace(/<badge>(?:.|\n)*?>/gm, '');
        html = `<span class="hover-text">${originText}</span><span class="regular-text text">${noBabgeText}</span>`;
      } else {
        html = `<span class="text">${html}</span>`;
      }
    }

    return html;
  }

  function linker(scope, element, attrs, ngModel) {
    if (!ngModel) {
      $log.error('Attribute "ng-model" required');
    }

    scope.$watch('fact.text_data', (text_data) => {
      const fact = ngModel.$modelValue;
      const short = element.attr('short') !== undefined;
      const hideSystemKeys = element.attr('hide-system-keys') !== undefined;
      const html = format_fact(fact, short, hideSystemKeys);
      element.html(html);
      $compile(element.contents())(scope);
      scope.$emit('text-compiled');
    });

  }

  return {
    restrict: 'E',
    require: 'ngModel',
    link: linker,
  };
}



// WEBPACK FOOTER //
// ./src/facts/text.component.js